exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div hr[data-v-6536be16] {\n  width: 50px;\n  height: 2px;\n  background: #222323;\n  display: inline-block;\n  margin: 20px 0;\n}", ""]);

// exports
